export const THEMES = {
    LIGHT: "light",
    DARK: "dark",
}

export const tempToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvd25lcklkIjoiMzVlZTk2YjktMzMzZC00ZGNjLWIwOWYtMmE0ZThlMTlkNGEyIiwic2Vzc2lvbklkIjoiZjAwNmI3OWItNWZjYS00YTAyLWFiOWMtZjBlMTgwZDllYTY3IiwiaWF0IjoxNzI0NzQ0MDU0fQ.6DWDR_BuuG8vBpOrz-cq8PZ_ljcfIQKCtRbdU9ftjPc"
// export const tempToken="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvd25lcklkIjoiZTU5NzBjMTQtMzk2Ni00ZjA0LTk0MjMtZDY4YWJhNzVkYjE5Iiwic2Vzc2lvbklkIjoiYTY0YWU4NTEtYzg1OS00MGUwLWJkYzMtZWVkNGQwNTdkYjE0IiwiaWF0IjoxNzI0NjY5MDY1fQ.DFHa7a1mF0nCmKF1v-0YCbmkqpXQXSkuTUvdulr8Umc"
